import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';

import ClickLink from 'App/components/styles/ClickLink';
import { formatDate } from 'App/services/DateService';
import useActivityDueDateModal from '../../hooks/useActivityDueDateModal';
import { cellPropsType } from '../../workQueue.constant';

const ActivityDueDateCell = ({ row, value }) => {
    const { setFieldValue } = useFormikContext();
    const onActivityDateClick = useCallback(
        (state) => setFieldValue('modalState.activityDateModal', state),
        [setFieldValue]
    );
    const modalState = useActivityDueDateModal(row);
    return (
        <span>
            <ClickLink onClick={() => onActivityDateClick(modalState)}>{formatDate(value)}</ClickLink>
        </span>
    );
};

ActivityDueDateCell.propTypes = cellPropsType;

export default ActivityDueDateCell;
